export const AVG_VISITS_PER_USER_FIELD = "avg_visits_per_user";
export const UNIQUE_VISITORS_FIELD = "visitors";
export const VISITS_FIELD = "visits";
export const AVG_MONTHLY_VISITS_FIELD = "avg_monthly_estimated_visits";
export const DESKTOP_VS_MOBILEWEB_VISITS_SHARE_FIELD = "desktop_vs_mobileweb_visits_share";
export const MOBILEWEB_VISITS_FIELD = "mobileweb_visits";
export const MOBILEWEB_VISITS_CHANGE_MOM_FIELD = "mobile_monthly_visits_change_mom";
export const VISIT_DURATION_FIELD = "avg_visit_duration";
export const DESKTOP_VISIT_DURATION_FIELD = "desktop_avg_visit_duration";
export const MOBILEWEB_VISIT_DURATION_FIELD = "mobileweb_avg_visit_duration";
export const PAGES_PER_VISIT_FIELD = "pages_per_visit";
export const DESKTOP_PAGES_PER_VISIT_FIELD = "desktop_pages_per_visit";
export const MOBILEWEB_PAGES_PER_VISIT_FIELD = "mobileweb_pages_per_visit";
export const PAGEVIEWS_FIELD = "pageviews";
export const DIRECT_VISITS_SHARE_FIELD = "direct_visits_share";
export const DIRECT_VISITS_CHANGE_MOM_FIELD = "direct_change_mom";
export const DIRECT_VISITS_CHANGE_YOY_FIELD = "direct_change_yoy";
export const LAST_MONTHS_DIRECT_VISITS_FIELD = "last_months_direct_visits";
export const DISPLAYADS_VISITS_SHARE_FIELD = "displayads_visits_share";
export const DISPLAYADS_VISITS_CHANGE_MOM_FIELD = "displayads_change_mom";
export const DISPLAYADS_VISITS_CHANGE_YOY_FIELD = "displayads_change_yoy";
export const LAST_MONTHS_DISPLAYADS_VISITS_FIELD = "last_months_displayads_visits";
export const REFERRALS_VISITS_SHARE_FIELD = "referrals_visits_share";
export const REFERRALS_VISITS_CHANGE_MOM_FIELD = "referrals_change_mom";
export const REFERRALS_VISITS_CHANGE_YOY_FIELD = "referrals_change_yoy";
export const LAST_MONTHS_REFERRALS_VISITS_FIELD = "last_months_referrals_visits";
export const MAIL_VISITS_SHARE_FIELD = "mail_visits_share";
export const MAIL_VISITS_CHANGE_MOM_FIELD = "mail_change_mom";
export const MAIL_VISITS_CHANGE_YOY_FIELD = "mail_change_yoy";
export const LAST_MONTHS_MAILS_VISITS_FIELD = "last_months_mail_visits";
export const SOCIAL_VISITS_SHARE_FIELD = "social_visits_share";
export const SOCIAL_VISITS_CHANGE_MOM_FIELD = "social_change_mom";
export const SOCIAL_VISITS_CHANGE_YOY_FIELD = "social_change_yoy";
export const LAST_MONTHS_SOCIAL_VISITS_FIELD = "last_months_social_visits";
export const ORGANIC_SEARCH_VISITS_SHARE_FIELD = "organic_search_visits_share";
export const ORGANIC_SEARCH_VISITS_CHANGE_MOM_FIELD = "organic_search_change_mom";
export const ORGANIC_SEARCH_VISITS_CHANGE_YOY_FIELD = "organic_search_change_yoy";
export const LAST_MONTHS_ORGANIC_SEARCH_VISITS_FIELD = "last_months_organic_search_visits";
export const PAID_SEARCH_VISITS_SHARE_FIELD = "paid_search_visits_share";
export const PAID_SEARCH_VISITS_CHANGE_MOM_FIELD = "paid_search_change_mom";
export const PAID_SEARCH_VISITS_CHANGE_YOY_FIELD = "paid_search_change_yoy";
export const LAST_MONTHS_PAID_SEARCH_VISITS_FIELD = "last_months_paid_search_visits";
export const ORGANIC_SOCIAL_VISITS_SHARE_FIELD = "organic_social_visits_share";
export const ORGANIC_SOCIAL_VISITS_CHANGE_MOM_FIELD = "organic_social_change_mom";
export const ORGANIC_SOCIAL_VISITS_CHANGE_YOY_FIELD = "organic_social_change_yoy";
export const LAST_MONTHS_ORGANIC_SOCIAL_VISITS_FIELD = "last_months_organic_social_visits";
export const PAID_SOCIAL_VISITS_SHARE_FIELD = "paid_social_visits_share";
export const PAID_SOCIAL_VISITS_CHANGE_MOM_FIELD = "paid_social_change_mom";
export const PAID_SOCIAL_VISITS_CHANGE_YOY_FIELD = "paid_social_change_yoy";
export const LAST_MONTHS_PAID_SOCIAL_VISITS_FIELD = "last_months_paid_social_visits";
export const GEN_AI_VISITS_SHARE_FIELD = "gen_ai_visits_share";
export const GEN_AI_VISITS_CHANGE_MOM_FIELD = "gen_ai_change_mom";
export const GEN_AI_VISITS_CHANGE_YOY_FIELD = "gen_ai_change_yoy";
export const LAST_MONTHS_GEN_AI_VISITS_FIELD = "last_months_gen_ai_visits";
export const AFFILIATE_VISITS_SHARE_FIELD = "affiliate_visits_share";
export const AFFILIATE_VISITS_CHANGE_MOM_FIELD = "affiliate_change_mom";
export const AFFILIATE_VISITS_CHANGE_YOY_FIELD = "affiliate_change_yoy";
export const LAST_MONTHS_AFFILIATE_VISITS_FIELD = "last_months_affiliate_visits";
export const SEARCH_VISITS_SHARE_FIELD = "search_visits_share";
export const SEARCH_VISITS_CHANGE_MOM_FIELD = "search_change_mom";
export const SEARCH_VISITS_CHANGE_YOY_FIELD = "search_change_yoy";
export const LAST_MONTHS_SEARCH_VISITS_FIELD = "last_months_search_visits";
export const INTERNATIONAL_VISITS_FIELD = "international_visits";
export const INTERNATIONAL_VISITS_SHARE_FIELD = "international_visits_share";
export const MONTHLY_VISITS_CHANGE_MOM_FIELD = "monthly_visits_change_mom";

export const BOUNCE_RATE_FIELD = "bounce_rate";
export const DESKTOP_BOUNCE_RATE_FIELD = "desktop_bounce_rate";
export const MOBILEWEB_BOUNCE_RATE_FIELD = "mobileweb_bounce_rate";

// Ad Spend Volume columns
export const TOTAL_AD_SPEND_FIELD = "total_ad_spend";
export const TOTAL_AD_SPEND_CHANGE_MOM_FIELD = "total_ad_spend_change_mom";
export const SEARCH_AD_SPEND_FIELD = "search_ad_spend";
export const SEARCH_AD_SPEND_CHANGE_MOM_FIELD = "search_ad_spend_change_mom";
export const DISPLAY_AD_SPEND_FIELD = "display_ad_spend";
export const DISPLAY_AD_SPEND_CHANGE_MOM_FIELD = "display_ad_spend_change_mom";
export const TOTAL_AD_ACTIVE_CAMPAIGNS_FIELD = "total_ad_active_campaigns";
export const SEARCH_AD_ACTIVE_CAMPAIGNS_FIELD = "search_ad_active_campaigns";
export const DISPLAY_AD_ACTIVE_CAMPAIGNS_FIELD = "display_ad_active_campaigns";
export const TOTAL_AD_NUMBER_FIELD = "total_ad_number";
export const SEARCH_AD_NUMBER_FIELD = "search_ad_number";
export const DISPLAY_AD_NUMBER_FIELD = "display_ad_number";
export const TOTAL_ADS_DESKTOP_SHARE_FIELD = "total_ads_desktop_share";
export const TOTAL_ADS_MOBILE_SHARE_FIELD = "total_ads_mobile_share";
export const SEARCH_ADS_DESKTOP_SHARE_FIELD = "search_ads_desktop_share";
export const SEARCH_ADS_MOBILE_SHARE_FIELD = "search_ads_mobile_share";
export const DISPLAY_ADS_DESKTOP_SHARE_FIELD = "display_ads_desktop_share";
export const DISPLAY_ADS_MOBILE_SHARE_FIELD = "display_ads_mobile_share";

// Display Ads Format columns
export const DISPLAY_ADS_BANNER_SHARE_FIELD = "display_ads_banner_share";
export const DISPLAY_ADS_VIDEO_SHARE_FIELD = "display_ads_video_share";
export const DISPLAY_ADS_NATIVE_SHARE_FIELD = "display_ads_native_share";

// Ad Spend Channels columns
export const SEARCH_CHANNEL_SHARE_FIELD = "search_channel_share";
export const DISPLAY_CHANNEL_SHARE_FIELD = "display_channel_share";
